import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const captionDefaultVariants = {
  "size": "md"
}
const captionCompoundVariants = []

const captionSlotNames = [
  [
    "root",
    "caption__root"
  ],
  [
    "item",
    "caption__item"
  ],
  [
    "avatar",
    "caption__avatar"
  ],
  [
    "icon",
    "caption__icon"
  ],
  [
    "text",
    "caption__text"
  ],
  [
    "count",
    "caption__count"
  ]
]
const captionSlotFns = /* @__PURE__ */ captionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, captionDefaultVariants, getSlotCompoundVariant(captionCompoundVariants, slotName))])

const captionFn = memo((props = {}) => {
  return Object.fromEntries(captionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const captionVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...captionDefaultVariants, ...compact(variants) })

export const caption = /* @__PURE__ */ Object.assign(captionFn, {
  __recipe__: false,
  __name__: 'caption',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: captionVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg",
    "xl"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, captionVariantKeys)
  },
  getVariantProps
})